import React from "react";
import moment from "moment";
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Checkbox } from "primereact/checkbox";
import { InputTextarea } from "primereact/inputtextarea";
import { Calendar } from "primereact/calendar";
import { validInput } from "../service/excelService.js";

const DialogForm = (props) => {
    var formDialog = props.formState;
    var onHide = props.hideFunct;
    var onChange = props.onChange;
    var categories = props.categories;
    var addOverseasDonor = props.addOverseasDonor;
    var addCC = props.addCC;
    var addCHQ = props.addCHQ;
    var addOverseas = props.addOverseas;
    var tempParams = props.tempParams;
    var setTempParams = props.setTempParams;
    var deleteMode = props.deleteMode;
    var onHideDeleteForm = props.hideDeleteFunct;
    var deleteDonorFunct = props.deleteFunct;
    var deletedDonor = props.deletedDonor;
    var inputErrors = props.errors;

    const renderFooter = () => {
		return (
            <div>
                <Button label="Cancel" icon="pi pi-times" onClick={onHide} className="p-button-text" />
                {(categories.length == 1 && categories.indexOf('Overseas Donor') !== -1) ? 
                <Button label="Submit" icon="pi pi-check" onClick={addOverseasDonor} autoFocus /> : (categories.length == 1 && categories.indexOf('Creditcard') !== -1) ? <Button label="Submit" icon="pi pi-check" onClick={addCC} autoFocus /> : (categories.length == 1 && categories.indexOf('Cheque') !== -1) ? <Button label="Submit" icon="pi pi-check" onClick={addCHQ} autoFocus /> : (categories.length == 1 && categories.indexOf('OverseasCC') !== -1) ? <Button label="Submit" icon="pi pi-check" onClick={addOverseas} autoFocus /> : null}
            </div>
		);
	};

    const deleteDonorDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={onHideDeleteForm} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteDonorFunct} />
        </React.Fragment>
    );

    const overseasDonorForm = () => {
        return (
            <div>
                <form className="form-horizontal">
                    <fieldset>
                        <div className="col-sm-6">
                            <h5>Overseas donor</h5>
                                <div>
                                    <InputTextarea id="overseasDonor" style={{fontSize: "1.5rem"}}
                                    onChange={(e) => setTempParams({...tempParams, "overseasDonorText": e.target.value})}
                                    placeholder="Input new Overseas Donor" 
                                    value={tempParams.overseasDonorText}
                                    rows={1} cols={50}></InputTextarea>
                                    <span className="error">{inputErrors["Donor"]}</span>
                                </div>
                        </div>
                        <div className="col-sm-6">
                            <h5>Start Date</h5>
                                <div>
                                    <Calendar id="overseasDonorDate" 
                                    onChange={(e) => setTempParams({...tempParams, "overseasDonorDate": moment(e.target.value).format("YYYY-MM-DD")})}
                                    value={tempParams.overseasDonorDate}
                                    readOnlyInput
                                    dateFormat="yy-mm-dd" style={{"width": "70%", "fontSize": "1.5rem"}} showIcon></Calendar>
                                    <span className="error">{inputErrors["DonorDate"]}</span>
                                </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        )
    }

    const creditcardForm = () => {
        return (
            <div>
                <form className="form-horizontal">
                    <fieldset>
                        <div className="col-sm-4">
                            <h5>Creditcard Charge Rate</h5>
                                <div>
                                    <InputTextarea id="CCCharge" style={{fontSize: "1.5rem"}}
                                    onChange={(e) => setTempParams({...tempParams, "CCChange": validInput(e.target.value)})}
                                    value={tempParams.rate}
                                    placeholder="Input New Rate" rows={1} cols={45}
                                    type="number"></InputTextarea>
                                    <span className="error">{inputErrors["CCRate"]}</span>
                                    </div>
                        </div>
                        <div className="col-sm-4">
                            <h5>Creditcard Transaction Rate</h5>
                                <div>
                                    <InputTextarea id="CCTrans" style={{fontSize: "1.5rem"}}
                                    onChange={(e) => setTempParams({...tempParams, "CCTransChange": validInput(e.target.value)})}
                                    value={tempParams.trans}
                                    placeholder="Input New Transaction Rate" rows={1} cols={45}
                                    type="number"></InputTextarea>
                                    <span className="error">{inputErrors["CCTrans"]}</span>
                                    </div>
                        </div>
                        <div className="col-sm-4">
                            <h5>Start Date</h5>
                                <div>
                                    <Calendar id="CCDate" 
                                    onChange={(e) => setTempParams({...tempParams, "CCDateChange": moment(e.target.value).format("YYYY-MM-DD")})}
                                    readOnlyInput
                                    dateFormat="yy-mm-dd" style={{"width": "70%", "fontSize": "1.5rem"}} showIcon></Calendar>
                                    <span className="error">{inputErrors["CCDate"]}</span>
                                </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        )
    }

    const chequeForm = () => {
        return (
            <div>
                <form className="form-horizontal">
                    <fieldset>
                        <div className="col-sm-4">
                            <h5>Cheque Charge Rate</h5>
                                <div>
                                <InputTextarea id="CHQCharge" style={{fontSize: "1.5rem"}}
                                onChange={(e) => setTempParams({...tempParams, "CHQChange": validInput(e.target.value)})}
                                value={tempParams.rate}
                                placeholder="Input New Rate" rows={1} cols={45}
                                type="number"></InputTextarea>
                                <span className="error">{inputErrors["CHQRate"]}</span>
                                </div>
                        </div>
                        <div className="col-sm-4">
                            <h5>Cheque Transaction Rate</h5>
                                <div>
                                <InputTextarea id="CHQTrans" style={{fontSize: "1.5rem"}}
                                onChange={(e) => setTempParams({...tempParams, "CHQTransChange": validInput(e.target.value)})}
                                value={tempParams.trans}
                                placeholder="Input New Transaction Rate" rows={1} cols={45}
                                type="number"></InputTextarea>
                                <span className="error">{inputErrors["CHQTrans"]}</span>
                                </div>
                        </div>
                        <div className="col-sm-4">
                            <h5>Start Date</h5>
                                <div>
                                <Calendar id="CHQDate" 
                                onChange={(e) => setTempParams({...tempParams, "CHQDateChange": moment(e.target.value).format("YYYY-MM-DD")})}
                                readOnlyInput
                                dateFormat="yy-mm-dd" style={{"width": "70%", "fontSize": "1.5rem"}} showIcon></Calendar>
                                <span className="error">{inputErrors["CHQDate"]}</span>
                                </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        )
    }

    const overseasCCForm = () => {
        return (
            <div>
                <form className="form-horizontal">
                    <fieldset>
                        <div className="col-sm-4">
                            <h5>Overseas Charge Rate</h5>
                                <div>
                                <InputTextarea id="OverseasCharge" style={{fontSize: "1.5rem"}}
                                onChange={(e) => setTempParams({...tempParams, "overseasChange": validInput(e.target.value)})}
                                value={tempParams.rate}
                                placeholder="Input New Rate" rows={1} cols={45}
                                type="number"></InputTextarea>
                                <span className="error">{inputErrors["overseasCCRate"]}</span>
                                </div>
                        </div>
                        <div className="col-sm-4">
                            <h5>Overseas Transaction Rate</h5>
                                <div>
                                <InputTextarea id="OverseasTrans" style={{fontSize: "1.5rem"}}
                                onChange={(e) => setTempParams({...tempParams, "overseasTransChange": validInput(e.target.value)})}
                                value={tempParams.trans}
                                placeholder="Input New Transaction Rate" rows={1} cols={45}
                                type="number"></InputTextarea>
                                <span className="error">{inputErrors["overseasCCTrans"]}</span>
                                </div>
                        </div>
                        <div className="col-sm-4">
                            <h5>Start Date</h5>
                                <div>
                                <Calendar id="OverseasDate" 
                                onChange={(e) => setTempParams({...tempParams, "overseasDateChange": moment(e.target.value).format("YYYY-MM-DD")})}
                                readOnlyInput
                                dateFormat="yy-mm-dd" style={{"width": "70%", "fontSize": "1.5rem"}} showIcon></Calendar>
                                <span className="error">{inputErrors["overseasCCDate"]}</span>
                                </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        )
    }

    return(
        <div>
            {(deleteMode == true) ? 
            <Dialog visible={deleteMode} style={{ width: '450px' }} header="Confirm" modal footer={deleteDonorDialogFooter} onHide={onHideDeleteForm}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '3rem'}} />
                    {deletedDonor && <span> Are you sure you want to delete <b>{deletedDonor.name}</b>?</span>}
                </div>
            </Dialog> :
            <Dialog header="Add New Overseas Donor or Charge Rate" visible={formDialog} footer={renderFooter()} onHide={onHide} maximizable dismissableMask>
                <div className="card">
                    <h5>Choose what you want to add</h5>
                    <div className="p-field-checkbox" style={{"fontSize":"1.2rem"}}>
                        <Checkbox inputId="cb1" value="Overseas Donor" onChange={onChange} checked={categories.indexOf('Overseas Donor') !== -1}/>
                        <label htmlFor="cb1" className="p-checkbox-label" style={{"marginLeft":"10px"}}>Overseas Donor</label>
                        <Checkbox inputId="cb2" value="Creditcard" onChange={onChange} checked={categories.indexOf('Creditcard') !== -1} style={{"marginLeft":"20px"}}/>
                        <label htmlFor="cb2" className="p-checkbox-label" style={{"marginLeft":"10px"}}>Creditcard</label>
                    </div>
                    <div className="p-field-checkbox" style={{"marginTop":"10px", fontSize:"1.2rem"}}>
                        <Checkbox inputId="cb3" value="Cheque" onChange={onChange} checked={categories.indexOf('Cheque') !== -1}/>
                        <label htmlFor="cb3" className="p-checkbox-label" style={{"marginLeft":"10px"}}>Cheque</label>
                        <Checkbox inputId="cb4" value="OverseasCC" onChange={onChange} checked={categories.indexOf('OverseasCC') !== -1} style={{"marginLeft":"60px"}}/>
                        <label htmlFor="cb4" className="p-checkbox-label" style={{"marginLeft":"10px"}}>Overseas CC</label>
                    </div>
                </div>
                <div className="card">
                    {(categories.indexOf('Overseas Donor') !== -1) ? overseasDonorForm() : (categories.indexOf('Creditcard') !== -1) ? creditcardForm() : (categories.indexOf('Cheque') !== -1) ? chequeForm() : (categories.indexOf('OverseasCC') !== -1) ? overseasCCForm(): null}
                </div>
            </Dialog>}
        </div>
    )
}

export default DialogForm;